import { format, parseISO } from 'date-fns';

export const displayDateFormat = 'dd-MMM-yyyy';
export const displayDateTimeFormat = 'dd-MMM-yyyy hh:mm a';

const timezoneSuffixPattern = /(z|[+-]\d{2}:?\d{2})$/i;

function parseDisplayDateValue(value: string | Date): Date {
  return typeof value === 'string' ? parseISO(value) : value;
}

export function normalizeUtcDateTimeString(value: string): string {
  if (timezoneSuffixPattern.test(value)) {
    return value;
  }

  return `${value}Z`;
}

export function parseUtcDateTimeValue(value: string | Date): Date {
  return typeof value === 'string' ? parseISO(normalizeUtcDateTimeString(value)) : value;
}

export function formatDisplayDate(value?: string | Date | null): string {
  if (!value) {
    return '';
  }

  try {
    return format(parseDisplayDateValue(value), displayDateFormat);
  } catch {
    return typeof value === 'string' ? value : '';
  }
}

export function formatDisplayDateTime(value?: string | Date | null): string {
  if (!value) {
    return '';
  }

  try {
    return format(parseDisplayDateValue(value), displayDateTimeFormat);
  } catch {
    return typeof value === 'string' ? value : '';
  }
}

export function formatDisplayUtcDateTime(value?: string | Date | null): string {
  if (!value) {
    return '';
  }

  try {
    return format(parseUtcDateTimeValue(value), displayDateTimeFormat);
  } catch {
    return typeof value === 'string' ? value : '';
  }
}

export function formatDateDateOnly(date: string | Date): string {
  return formatDisplayDate(date);
}

export function parseDateOnly(date: string): Date {
  const split = date.split('-');
  return new Date(parseInt(split[0]), parseInt(split[1]) - 1, parseInt(split[2]));
}
